import React, { useCallback } from "react";
import ReactTooltip from "react-tooltip";

import styles from "./styles.css";

const BASE_MAX_CHARACTERS_PER_LINE = 45;


const Tooltip = ({ children, id, tooltipContent }) => {
	const getContent = useCallback(() => {
		if (!tooltipContent) {
			return null;
		}

		const sourceString = String(tooltipContent);

		if (sourceString.length <= 43) {
			return sourceString;
		}

		let str = "";
		let lineNumber = 1;
		const lineBreak = "<br />";
		const text = sourceString.split(" ");

		for (let i = 0; i < text.length; i++) {
			const maxCharactersPerLine = lineNumber > 1
				? BASE_MAX_CHARACTERS_PER_LINE * lineNumber - lineBreak.length
				: BASE_MAX_CHARACTERS_PER_LINE * lineNumber;

			if ((str.length + text[i].length) <= maxCharactersPerLine) {
				str += `${text[i]} `;
			} else {
				str += lineBreak;
				lineNumber++;
			}
		}

		return str;
	}, [ tooltipContent ]);

	if (!tooltipContent) {
		return children;
	}

	return (
		<div className={styles.tooltipWrapper}>
			{React.cloneElement(children, { id })}
			<span
				tabIndex={0}
				data-tip=""
				data-for={"additional-info-tooltip" + id}
				role="tooltip"
				className={styles.tooltipIcon}
				aria-describedby={id}
				data-html={true}
			>
				<img alt="black circle with 'I' letter inside" src="data:image/svg+xml;base64,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" />
			</span>
			<ReactTooltip
				className={styles.infoTooltip}
				effect="solid"
				id={"additional-info-tooltip" + id}
				html={true}
				multiline={true}
				getContent={getContent}
			/>
		</div>
	);
};

export default Tooltip;
